import { CustomResponeData } from 'axios'
import http from '../axios/index'
import { CityItem } from './types'
import { reportInfo, reportWarn } from '../owl'

export const DEFAULT_CITY_ID = 310100
export const DEFAULT_CITY = { id: DEFAULT_CITY_ID, chineseName: '上海', fallback: true }

// 城市列表
export const getOnSaleCity = () => {
  return http
    .get<CustomResponeData<{ hotOpenAdList: []; openAdInfoList: [] }>>('/gis/api/v1/admindivision/queryOpenAdList', {
      cache: true,
    })
    .then((res) => {
      const { hotOpenAdList: hotCities, openAdInfoList: cities } = res
      return { hotCities, cities }
    })
}

const onSaleCityCache: Record<string, {}> = {}
export const isOnSaleCity = (cityId: number) => {
  if (onSaleCityCache[cityId]) return onSaleCityCache[cityId]
  return http
    .get<CustomResponeData<CityItem>>(`/cprod/api/v1/gis/isOnSaleCity/${cityId}`, {
      cache: true,
    })
    .then((res) => {
      onSaleCityCache[cityId] = res
      return res
    })
    .catch((err) => {
      if (err && err.status !== 0) {
        reportWarn({
          name: '经纬度获取城市出错1',
          global: true,
          msg: err,
        })
      }
      return true
    })
}

export const getCityByCityId = (cityId: number) => {
  return http.get<CustomResponeData<CityItem>>(`/cprod/api/v1/gis/queryCityById/${cityId}`, {
    cache: true,
  })
}

export const geo2phx = ({ longitude, latitude }: { longitude: number; latitude: number }) => {
  if (!longitude || !latitude) {
    return Promise.reject({
      status: -1,
      message: '经纬度信息错误',
    })
  }
  return http
    .post<CustomResponeData<CityItem>>(
      `/cprod/api/v1/gis/locByCoorWithOversae`,
      { longitude, latitude },
      {
        cache: true,
      },
    )
    .then((res) => {
      if (!res || !res.id) {
        reportWarn({
          name: '经纬度获取城市出错2',
          global: true,
          msg: longitude + ',' + latitude,
        })
        return DEFAULT_CITY_ID
      }
      return res.id
    })
}

interface CityItem_FULL {
  id: number
  chineseName: string
  parentId: number
  parentName: string
}

// 1.民宿 2.美团 3.点评
export const transCityIdByType = (cityId: number, type: number): Promise<CityItem> => {
  if (!cityId) {
    return Promise.resolve(DEFAULT_CITY)
  }
  const typeMap: Record<string, string> = {
    1: '民宿',
    2: '美团',
    3: '点评',
  }
  if ([1, 2, 3].indexOf(type) !== -1) {
    return http
      .post<CustomResponeData<CityItem_FULL>>(
        '/gis/api/v1/admindivision/queryOpenAdInfo',
        {
          cityId,
          type,
        },
        {
          cache: true,
        },
      )
      .then((res) => {
        if (!res || !res.id) {
          reportInfo({
            global: true,
            name: typeMap[type] + '城市无对应民宿城市',
            msg: cityId,
          })
          return DEFAULT_CITY
        }
        const { id, chineseName, parentId, parentName } = res
        if (parentId) {
          return {
            id: parentId,
            chineseName: parentName,
          }
        }
        return {
          id,
          chineseName,
        }
      })
  }
  return Promise.resolve(DEFAULT_CITY)
}
